//copy
function copyText(el, text) {
    navigator.clipboard.writeText(text).then(() => {
        const originalText = el.textContent;  // 保存原始文本
        el.textContent = 'copied';            // 修改为 copied
        setTimeout(() => {
            el.textContent = originalText;    // 2 秒后恢复
        }, 3000);
    })
}

function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

var wFlag=window.innerWidth>750


const el = document.querySelector('.springSale');
if(el){
    const target = el.previousElementSibling;
    if (target && target.classList.contains('product-form__actions')) {
        target.classList.add('hide_actions');
    }
}

$(()=>{
    showUp('.box1_line div')
    showUp('.box2_title')
    showUp('.box3_title')
    showUp('.box4_title')
    showUp('.box5 .box5_title')
    showUp('.box6 .box5_title')

    $('.box1_btn').click(function(){
        var element = document.querySelector(".box2");
        element.scrollIntoView({block: "start",behavior: "smooth",});
    })

    $('.box3Swiper').hover(function(){
        $('.box3s_icon').css({opacity:1})
    },function(){
        $('.box3s_icon').css({opacity:0})
    })

    if(wFlag){
        new Swiper('.box3Swiper', {
            //autoplay: true,
            slidesPerView : 2.5,
            navigation: {
                nextEl: '.box3Swiper .box3Swiper-button-next',
                prevEl: '.box3Swiper .box3Swiper-button-prev',
            },
        })
    }else{
        new Swiper('.box2Swiper', {
            autoplay: true,
            navigation: {
                nextEl: '.Mbox2_nav img:nth-child(2)',
                prevEl: '.Mbox2_nav img:nth-child(1)',
            },
        })
    }

    $('.box3Btn').click(function(){
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'SZUwHN']);
    })
    
    $('.box3_nav div').click(function(){
        var index = $(this).index()
        $(this).addClass('box3Active').siblings().removeClass('box3Active')
        $('.box3_content .box3c_items').eq(index).addClass('block').siblings().removeClass('block')
    })

    new Swiper('.box4Swiper', {
        speed:8000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          //waitForTransition: false,
        },
        slidesPerView :wFlag?4:1.2,
        loop:true
    })
})